var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 16,
    viewBox: "0 0 263 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.244 0H1.755A1.754 1.754 0 0 0 0 1.756v75.489A1.754 1.754 0 0 0 1.755 79h75.49A1.754 1.754 0 0 0 79 77.245V1.755A1.754 1.754 0 0 0 77.244 0zM52.666 50.91a1.755 1.755 0 0 1-1.755 1.757H28.09a1.757 1.757 0 0 1-1.757-1.756V28.09a1.755 1.755 0 0 1 1.756-1.757H50.91a1.754 1.754 0 0 1 1.757 1.756V50.91z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.267 26h-22.534c-.957 0-1.733.806-1.733 1.8v23.4c0 .994.776 1.8 1.733 1.8h22.534c.957 0 1.733-.806 1.733-1.8V27.8c0-.994-.776-1.8-1.733-1.8z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2 0h-23.4c-.994 0-1.8.776-1.8 1.733v22.534c0 .957.806 1.733 1.8 1.733h23.4c.994 0 1.8-.776 1.8-1.733V1.733C211 .776 210.194 0 209.2 0z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.267 0h-22.534C237.776 0 237 .776 237 1.733v22.534c0 .957.776 1.733 1.733 1.733h22.534c.957 0 1.733-.776 1.733-1.733V1.733C263 .776 262.224 0 261.267 0z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2 53h-23.4c-.994 0-1.8.776-1.8 1.733v22.534c0 .957.806 1.733 1.8 1.733h23.4c.994 0 1.8-.776 1.8-1.733V54.733c0-.957-.806-1.733-1.8-1.733z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M261.267 53h-22.534c-.957 0-1.733.776-1.733 1.733v22.534c0 .957.776 1.733 1.733 1.733h22.534c.957 0 1.733-.776 1.733-1.733V54.733c0-.957-.776-1.733-1.733-1.733z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.267 0h-22.534C145.776 0 145 .776 145 1.733v22.534c0 .957.776 1.733 1.733 1.733h22.534c.957 0 1.733-.776 1.733-1.733V1.733C171 .776 170.224 0 169.267 0z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.267 53h-22.534c-.957 0-1.733.776-1.733 1.733v22.534c0 .957.776 1.733 1.733 1.733h22.534c.957 0 1.733-.776 1.733-1.733V54.733c0-.957-.776-1.733-1.733-1.733z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145 28.083c0-.466-.186-.912-.517-1.242a1.774 1.774 0 0 0-1.25-.513H118.5V1.757c0-.467-.186-.913-.517-1.243a1.773 1.773 0 0 0-1.25-.514H93.767a1.77 1.77 0 0 0-1.25.514A1.75 1.75 0 0 0 92 1.757v75.487c0 .466.186.912.518 1.241.33.33.78.515 1.249.515h22.966c.47 0 .918-.185 1.25-.515.33-.329.517-.775.517-1.241v-24.57h24.733c.47 0 .918-.186 1.25-.515.33-.33.517-.777.517-1.243V28.083z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.2f8ea9beccd8e6946103ef6886efe56c.svg";
export { ForwardRef as ReactComponent };